import React, { useEffect, useState, useMemo } from 'react';
import { Voucher } from '@lux/graphics';
import { MessageDialog, Size } from '@lux/dialog';
import { screenSizes } from '@lux/tokens';
import { tracker } from '../tracking';
import { defineCardContent } from './helpers';
export var BrazeCard = function (_a) {
    var cards = _a.cards, cardMethodsFromBraze = _a.cardMethodsFromBraze;
    var _b = useState(true), showCard = _b[0], setShowCard = _b[1];
    // always take the newest campaign
    var singleCard = cards[0];
    var itemCard = defineCardContent(singleCard);
    var size = window.screen.width > screenSizes.xs ? Size.M : Size.S;
    var logContentCardImpressions = cardMethodsFromBraze.logContentCardImpressions, logCardDismissal = cardMethodsFromBraze.logCardDismissal, logCardClick = cardMethodsFromBraze.logCardClick;
    var trackingPayload = useMemo(function () { return ({
        cardContentId: singleCard.id,
        brazeVoucher: itemCard.brazeVoucher,
        brazeVoucherExpire: itemCard.brazeVoucherExpire,
    }); }, [singleCard.id, itemCard.brazeVoucher, itemCard.brazeVoucherExpire]);
    useEffect(function () {
        logContentCardImpressions(cards);
        tracker.track('braze_web_contentCard_shown', trackingPayload);
    }, [cards, logContentCardImpressions, singleCard.id, trackingPayload]);
    var hideContentCard = function () {
        setShowCard(false);
        logCardDismissal(singleCard);
        tracker.track('braze_web_contentCard_closed', trackingPayload);
    };
    var handleCtaClick = function () {
        setShowCard(false);
        logCardClick(singleCard, true);
        tracker.track('braze_web_contentCard_CTAClick', trackingPayload);
        window.location.assign(itemCard.url);
    };
    return itemCard && showCard ? (React.createElement(MessageDialog, { isShown: showCard, size: size, graphic: React.createElement(Voucher, null), closeDialog: hideContentCard, title: itemCard.title, text: itemCard.message, positiveButtonText: itemCard.ctaText, positiveButtonProps: {
            onClick: function () {
                handleCtaClick();
            },
        }, footNote: itemCard.footNote })) : null;
};
